import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import PropertiesPage from './pages/properties/PropertiesPage';
import PropertyDetailsPage from './pages/properties/PropertyDetailsPage';
import ListingEditorPage from './pages/properties/ListingEditorPage';
import TenantsPage from './pages/tenants/TenantsPage';
import AccountingPage from './pages/accounting/AccountingPage';
import GeneralLedgerPage from './pages/accounting/GeneralLedgerPage';
import BankingPage from './pages/accounting/BankingPage';
import MaintenancePage from './pages/maintenance/MaintenancePage';
import BillsPage from './pages/accounting/BillsPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import GoogleCallback from './pages/auth/GoogleCallback';
import LandingPage from './pages/LandingPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LandlordProfilePage from './pages/profile/LandlordProfilePage';
import CompliancePage from './pages/properties/CompliancePage';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/oauth/google" element={<GoogleCallback />} />

          {/* Protected routes - Dashboard */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="properties" element={<PropertiesPage />} />
            <Route path="properties/:id" element={<PropertyDetailsPage />} />
            <Route path="properties/:id/listing" element={<ListingEditorPage />} />
            <Route path="properties/:id/compliance" element={<CompliancePage />} />
            <Route path="tenants" element={<TenantsPage />} />
            <Route path="accounting" element={<AccountingPage />} />
            <Route path="accounting/general-ledger" element={<GeneralLedgerPage />} />
            <Route path="accounting/banking" element={<BankingPage />} />
            <Route path="accounting/bills" element={<BillsPage />} />
            <Route path="maintenance" element={<MaintenancePage />} />
            <Route path="profile" element={<LandlordProfilePage />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  );
}

export default App;
